import { format, isThisYear } from "date-fns";

import type { GetTasksQueryParamsV4 } from "@fartherfinance/frontend/api/TaskWorkflows/requests/getTasks";

import {
  extractSortParts,
  mapToTableSortOrder,
} from "@src/multiCustodian/utils/sorting";
import type { Column } from "@src/sharedComponents/Table/Types";

import type { TaskTableColumns } from "./TasksTable";

export const formatTaskDate = (date: Date): string => {
  const dateFormat = isThisYear(date) ? "LLL d" : "LLL yyyy";

  return format(date, dateFormat);
};

export const createTableColumns = (
  sort: GetTasksQueryParamsV4["sort"],
  leftActionComponent?: React.ReactNode | undefined
): Column<TaskTableColumns>[] => {
  const { sortBy, sortOrder } = extractSortParts(sort);

  return [
    leftActionComponent !== undefined
      ? { label: leftActionComponent, accessor: "actionLeft", sortable: false }
      : { label: "Title", accessor: "title", sortable: false },

    {
      label: "Assignee",
      accessor: "assignee",
      sortable: true,
      active: sortBy === "assignee",
      sortOrder: mapToTableSortOrder(sortOrder),
    },
    {
      label: "Client",
      accessor: "client",
      sortable: true,
      active: sortBy === "client",
      sortOrder: mapToTableSortOrder(sortOrder),
    },
    {
      label: "Advisor",
      accessor: "advisor",
      sortable: true,
      active: sortBy === "advisor",
      sortOrder: mapToTableSortOrder(sortOrder),
    },
    {
      label: "Status",
      accessor: "taskStatus",
      sortable: true,
      active: sortBy === "taskStatus",
      sortOrder: mapToTableSortOrder(sortOrder),
    },
    {
      label: "Type",
      accessor: "taskType",
      sortable: true,
      active: sortBy === "taskType",
      sortOrder: mapToTableSortOrder(sortOrder),
    },
    {
      label: "Updated",
      accessor: "updatedTs",
      sortable: true,
      active: sortBy === "updatedTs",
      sortOrder: mapToTableSortOrder(sortOrder),
    },
    {
      label: "Due",
      accessor: "dueDate",
      sortable: true,
      active: sortBy === "dueDate",
      sortOrder: mapToTableSortOrder(sortOrder),
    },
  ];
};
